// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__2iR-9","expandIconWrapper":"CustomNode_expandIconWrapper__3N9nH","isOpen":"CustomNode_isOpen__3vemy","labelGridItem":"CustomNode_labelGridItem__MI9n2"};